/**
 * Created by Valeria Nazarova
 * Date: 07.03.2023
 */

import React from 'external/react';
import PropTypes from 'external/prop-types';
import Icon from '../components/Icon';
import '../css/situation-status-icons.scss';

const SituationStatusIcons = ({ isActive, isShared }) => {
    console.log('isActive, isShared', isActive, isShared);
    return (
        <React.Fragment>
            <Icon
                name={isActive ? 'active ic-active' : 'inactive ic-inactive'}
                title={isActive ? 'Aktiv' : 'Inaktiv'}
                className="icon-active-size mr-3"
            />
            <Icon
                name={isShared ? 'share ic-active' : 'not-shared ic-inactive'}
                title={isShared ? 'Geteilt' : 'Nicht geteilt'}
                className="icon-shared-size mr-3"
            />
        </React.Fragment>
    );
};

SituationStatusIcons.propTypes = {
    isActive: PropTypes.bool.isRequired,
    isShared: PropTypes.bool.isRequired,
};

export default SituationStatusIcons;



// WEBPACK FOOTER //
// ./js/components/SituationStatusIcons.jsx